import './LabelWithDescription.scss';
import classnames from 'classnames';
import { Tooltip } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';

export const LabelWithDescription: React.FC<{
	icon?: React.ReactNode;
	label: string | React.ReactNode;
	description?: string | React.ReactNode;
	required?: boolean;
	badges?: React.ReactNode;
	customClassName?: string;
	showDescriptionDirectly?: boolean;
	'data-testid'?: string;
}> = ({
	icon,
	label,
	description,
	badges,
	required,
	customClassName,
	showDescriptionDirectly = false,
	'data-testid': testId,
}) => {
	const baseClass = 'label-with-description';

	return (
		<div
			className={classnames(baseClass, {
				[`${customClassName}`]: !!customClassName,
			})}
			data-testid={testId}
		>
			<h2
				className={classnames(`${baseClass}__label`, {
					[`${baseClass}__label-with-required`]: !!required,
				})}
			>
				<div className="flex items-center justify-between w-full">
					<span className="flex items-center gap-2">
						{icon && icon}
						<span className="text-lg">{label}</span>
						{description && !showDescriptionDirectly && (
							<Tooltip title={description}>
								<InfoCircleOutlined
									style={{ fontSize: '12px' }}
									className="text-gray-400 cursor-help"
								/>
							</Tooltip>
						)}
					</span>
					<span className="mr-8">{badges}</span>
				</div>
			</h2>
			{description && showDescriptionDirectly && (
				<p className="text-gray-600 text-sm mt-1" data-testid={`${testId}-description`}>
					{description}
				</p>
			)}
		</div>
	);
};
